/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Info_Delete_Success_ToastInputs */



/**
* | output |
* | --- |
* | "\"{name}\" was deleted successfully" |
*
* @param {Explorer_Info_Delete_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_delete_success_toast = /** @type {((inputs: Explorer_Info_Delete_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Delete_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`"${i?.name}" supprime avec succes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`"${i?.name}" wurde erfolgreich gelöscht`)
	if (locale === "it") return /** @type {LocalizedString} */ (`"${i?.name}" è stato eliminato correttamente`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`"${i?.name}" был успешно удален`)
	if (locale === "es") return /** @type {LocalizedString} */ (`"${i?.name}" se eliminó correctamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`“${i?.name}”已成功删除`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.name}」は正常に削除されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`"${i?.name}" सफलतापूर्वक हटा दिया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`"${i?.name}" foi excluído com sucesso`)
	return /** @type {LocalizedString} */ (`"${i?.name}" was deleted successfully`)
});